export default __webpack_public_path__ + "static/media/Milo.3a752405.png";